export const EmailLinkStyles = {
  icon: (cssLogoClasses: string | undefined) => cssLogoClasses ?? 'mr-4',
  link: (className: string = '') => `${className} flex items-center `,
}
